module.exports = __webpack_public_path__ + "static/media/immotech-logo.f6f9c03a.svg";